export default __webpack_public_path__ + "static/media/CNo.70-5.a7dee0b3.jpg";